import { render, staticRenderFns } from "./iDialogInfo.vue?vue&type=template&id=55efff53&"
import script from "./iDialogInfo.vue?vue&type=script&lang=js&"
export * from "./iDialogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports